/**
 * Channel-specific activity-log `type` → display-name pairs (e.g. `sent_sms` → "Sent SMS").
 *
 * This is a static `{ logType: displayName }` map. Once the channel registry lives in Hydra,
 * these names should be re-derived from it so a newly-added channel type gets a label
 * automatically instead of falling back to its raw value. Until then, a channel type missing
 * here renders raw.
 */
export const CHANNEL_LOG_TYPE_NAMES: Record<string, string> = {
  attempted_email: 'Attempted To Send Email',
  attempted_in_app: 'Attempted To Send In-App Message',
  attempted_inbox: 'Attempted To Send Inbox Message',
  attempted_line: 'Attempted To Send LINE Message',
  attempted_live_notification: 'Attempted To Send Live Notification',
  attempted_push: 'Attempted To Send Push Notification',
  attempted_slack: 'Attempted To Send Slack Message',
  attempted_sms: 'Attempted to send SMS',
  attempted_twilio: 'Attempted To Send SMS',
  attempted_webhook: 'Attempted To Send Webhook',
  attempted_whatsapp: 'Attempted To Send WhatsApp Message',
  bounced_email: 'Bounced Email',
  bounced_live_notification: 'Bounced Live Notification',
  bounced_push: 'Bounced Push Notification',
  bounced_sms: 'Bounced SMS',
  bounced_twilio: 'Bounced SMS',
  clicked_email: 'Clicked Email',
  clicked_in_app: 'Clicked In-App Message',
  clicked_line: 'Clicked LINE Message',
  clicked_push: 'Clicked Push Notification',
  clicked_sms: 'Clicked SMS',
  clicked_twilio: 'Clicked SMS',
  clicked_webhook: 'Clicked Webhook',
  converted_email: 'Converted Email',
  converted_in_app: 'Converted In-App Message',
  converted_inbox: 'Converted Inbox Message',
  converted_line: 'Converted LINE Message',
  converted_slack: 'Converted Slack Message',
  converted_sms: 'Converted SMS',
  converted_twilio: 'Converted SMS',
  converted_webhook: 'Converted Webhook',
  converted_whatsapp: 'Converted WhatsApp Message',
  deferred_email: 'Deferred Email',
  deferred_in_app: 'Deferred In-App Message',
  deferred_inbox: 'Deferred Inbox Message',
  deferred_push: 'Deferred Push Notification',
  deferred_slack: 'Deferred Slack Message',
  deferred_sms: 'Deferred SMS',
  deferred_twilio: 'Deferred SMS',
  deferred_webhook: 'Deferred Webhook',
  delivered_email: 'Delivered Email',
  delivered_line: 'Delivered LINE Message',
  delivered_live_notification: 'Delivered Live Notification',
  delivered_push: 'Delivered Push Notification',
  delivered_sms: 'Delivered SMS',
  delivered_twilio: 'Delivered SMS',
  delivered_whatsapp: 'Delivered WhatsApp Message',
  drafted_email: 'Drafted Email',
  drafted_in_app: 'Drafted In-App Message',
  drafted_inbox: 'Drafted Inbox Message',
  drafted_push: 'Drafted Push Notification',
  drafted_slack: 'Drafted Slack Message',
  drafted_sms: 'Drafted SMS',
  drafted_twilio: 'Drafted SMS',
  drafted_webhook: 'Drafted Webhook',
  dropped_email: 'Suppressed Email',
  failed_email: 'Failed to Send Email',
  failed_in_app: 'Failed to Send In-App Message',
  failed_inbox: 'Failed to Send Inbox Message',
  failed_line: 'Failed to Send LINE Message',
  failed_live_notification: 'Failed to Send Live Notification',
  failed_push: 'Failed to Send Push Notification',
  failed_slack: 'Failed to Send Slack Message',
  failed_sms: 'Failed to send SMS',
  failed_twilio: 'Failed to Send SMS',
  failed_webhook: 'Failed to Send Webhook',
  failed_whatsapp: 'Failed to Send WhatsApp Message',
  opened_email: 'Opened Email',
  opened_in_app: 'Opened In-App Message',
  opened_inbox: 'Opened Inbox Message',
  opened_push: 'Opened Push Notification',
  opened_whatsapp: 'Opened WhatsApp Message',
  replied_sms: 'Replied to SMS',
  replied_twilio: 'Replied to SMS',
  replied_whatsapp: 'Replied to WhatsApp Message',
  sent_email: 'Sent Email',
  sent_in_app: 'Sent In-App Message',
  sent_inbox: 'Sent Inbox Message',
  sent_line: 'Sent LINE Message',
  sent_live_notification: 'Sent Live Notification',
  sent_push: 'Sent Push Notification',
  sent_slack: 'Sent Slack Message',
  sent_sms: 'Sent SMS',
  sent_twilio: 'Sent SMS',
  sent_webhook: 'Sent Webhook',
  sent_whatsapp: 'Sent WhatsApp Message',
  spammed_email: 'Spammed Email',
  suppressed_sms: 'Suppressed SMS',
  suppressed_twilio: 'Suppressed SMS',
  topic_unsubscribed_email: 'Topics Unsubscribed Email',
  undeliverable_email: 'Undeliverable Email',
  undeliverable_in_app: 'Undeliverable In-App Message',
  undeliverable_inbox: 'Undeliverable Inbox Message',
  undeliverable_live_notification: 'Undeliverable Live Notification',
  undeliverable_push: 'Undeliverable Push Notification',
  undeliverable_slack: 'Undeliverable Slack Message',
  undeliverable_sms: 'Undeliverable SMS',
  undeliverable_twilio: 'Undeliverable SMS',
  undeliverable_webhook: 'Undeliverable Webhook',
  unsubscribed_email: 'Unsubscribed Email',
};
